import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        paddingTop: theme.spacing(2),
    },
    sectionSubtitle: {
        margin: 0,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        color: theme.palette.text.primary,
    },
    card: {
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    settingsGroupTitle: {
        margin: 0,
        padding: theme.spacing(1, 0, 0.5),
        fontSize: theme.typography.pxToRem(17),
        lineHeight: 1.35,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.text.primary,
        "&:not(:first-of-type)": {
            paddingTop: theme.spacing(2.5),
        },
    },
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(2),
        padding: theme.spacing(2, 3),
        borderBottom: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)"}`,
    },
    rowContent: {
        minWidth: 0,
        flex: 1,
    },
    labelRow: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    leadingIconSlot: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: theme.spacing(3),
        marginRight: theme.spacing(1),
    },
    title: {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: 1.4,
        fontWeight: 600,
    },
    description: {
        fontSize: theme.typography.pxToRem(13),
        lineHeight: 1.45,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
    },
    shieldIcon: {
        color: theme.palette.warning.main,
        fontSize: 18,
    },
}));
